import { Component, OnInit } from '@angular/core';
import {Model} from '../../app.model';
import {CountryService} from '../../country/country.service';
import {CompanyService} from '../company.service';
import {AutorunComponent} from '@myshared/autorun.component';
import {MessageService} from 'primeng/api';
import {BankAccount} from '../company.model';
import {I18NextService} from 'angular-i18next';
import {FormEmitter} from "../../forms/form.component";

@Component({
    selector: 'app-company-payment-details',
    templateUrl: './company-payment-details.component.html',
    styleUrls: [],
    standalone: false
})
export class CompanyPaymentDetailsComponent extends AutorunComponent implements OnInit {
  bankAccount: BankAccount;

  constructor(private m: Model,
              private countryService: CountryService,
              private companyService: CompanyService,
              private messageService: MessageService,
              private i18next: I18NextService) {
    super();
  }

  ngOnInit() {
    this.autorun(() => {
      if (this.m.company.company.bankAccounts.length > 0) {
        this.bankAccount = this.m.company.company.bankAccounts[0];
      } else {
        this.bankAccount = BankAccount.fromJson({});
      }
    });
    this.countryService.refresh();
    this.companyService.refresh();
  }

  onUpdate(form: FormEmitter<BankAccount>) {
    const bankAccount = form.data;
    bankAccount.id = this.bankAccount.id;
    this.companyService.updateBankAccount(bankAccount).subscribe(r => {
      if (r) {
        this.messageService.add({severity: 'success',
          summary: this.i18next.t('company_bankaccount_update_success_summary') as string,
          detail: this.i18next.t('company_bankaccount_update_success_detail') as string});
      } else {
        this.messageService.add({severity: 'error',
          summary: this.i18next.t('company_bankaccount_update_error_summary') as string,
          detail: this.i18next.t('company_bankaccount_update_error_detail') as string});
      }
    });
  }
}
